import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";

export class PhotoSettings extends Record {
    constructor(imageWidth, imageHeight) {
        super();
        this.imageWidth = (imageWidth | 0);
        this.imageHeight = (imageHeight | 0);
    }
}

export function PhotoSettings_$reflection() {
    return record_type("Browser.Types.PhotoSettings", [], PhotoSettings, () => [["imageWidth", int32_type], ["imageHeight", int32_type]]);
}

